<template>
   <app-master>

       <div slot='breadcrumb'>
         <app-breadcrumb>
             <div class="title-box ttm-textcolor-white">
                <div class="page-title-heading">
                    <h1 class="title">Farmland Subscription</h1>
                </div><!-- /.page-title-captions -->
                <div class="breadcrumb-wrapper">
                    <div class="container">
                        <div class="breadcrumb-wrapper-inner">
                            <span>
                                <router-link class="home" title='Go to AgroPark' to='/'><i class="themifyicon ti-home"></i>&nbsp;&nbsp;Home </router-link>
            
                            </span>
                            <span class="ttm-bread-sep">&nbsp; | &nbsp;</span>
                            <span>Farmland Subscription</span>
                        </div>
                    </div>
                </div>
            </div>
         </app-breadcrumb>
       </div>
        



      <div slot='main_content'>

        

         <section class="ttm-row pb-50 clearfix">
            <div class="container">
                <!-- row -->
                <div class="row">
                    <div class="col-lg-12">
                        <!-- ttm-pf-single-content-wrapper-innerbox -->
                        <div class="ttm-pf-single-content-wrapper-innerbox ttm-pf-view-left-image">
                            <div class="ttm-pf-detail-box">
                                <div class="row">
                                    <div class="col-lg-8">
                                        <div class="ttm-featured-wrapper ttm-portfolio-featured-wrapper">
                                            <img class="img-fluid" src="/img/famsub1.png" alt="">
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <div class="ttm-pf-single-detail-box res-991-mt-30">
                                            <div class="ttm-pf-detailbox">
                                                <ul class="ttm-pf-detailbox-list">
                                                    <li class="ttm-pf-details-date">
                                                        <span class="ttm-pf-left-details"><i class="fa fa-medkit"></i>Lease Purchase </span>
                                                        <span class="ttm-pf-right-details">10 years</span>
                                                    </li>
                                                    <li class="ttm-pf-details-date">
                                                        <span class="ttm-pf-left-details"><i class="fa fa-user"></i> Outright Purchase </span>
                                                        <span class="ttm-pf-right-details">90 years</span>
                                                    </li>
                                                    <li class="ttm-pf-details-date">
                                                        <span class="ttm-pf-left-details"><i class="fa fa-user-md"></i>Doctor </span>
                                                        <span class="ttm-pf-right-details">Dr. Teresa Mayer</span>
                                                    </li>
                                                    <li class="ttm-pf-details-date">
                                                        <span class="ttm-pf-left-details"><i class="fa fa-stethoscope"></i>Category </span>
                                                        <span class="ttm-pf-right-details">Neurology</span>
                                                    </li>
                                                    <li class="ttm-pf-details-date">
                                                        <span class="ttm-pf-left-details"><i class="fa fa-calendar"></i>Date </span>
                                                        <span class="ttm-pf-right-details">25th November 2018</span>
                                                    </li>
                                                    <li class="ttm-pf-details-date">
                                                        <span class="ttm-pf-left-details"><i class="fa fa-map-marker"></i>Location </span>
                                                        <span class="ttm-pf-right-details">Ajale-Orile, Abeokuta</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ttm-pf-single-content-area">
                                <div class="ttm-portfolio-description">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <h4>Did You Know?</h4>
                                            <div class="sep_holder_box width-100 mb-20">
                                                <span class="sep_holder"><span class="sep_line"></span></span>
                                                <span class="sep_holder"><span class="sep_line"></span></span>
                                            </div>
                                            <p> Farmland is a resource to its owner. It becomes an asset when cultivated. Many people and organisations are unable to take advantage of the appreciation of their asset as they are faced with issues such as fertility, maintenance, and ultimately, profitability. This underscores the importance of savvy managers that can help you maximise the appreciation of your asset, and of your returns on investment. </p>
                                            <p>You can own farmland to cultivate any of the available crops through outright acquisition. We provide you a crop advice on available crops for the planting season. Crops have varying life cycle, cost of investment and ROI. Land ownership tenure is 90 years. Please see the crop template for the available crops.</p>
                                            <p>You can also acquire land by leasehold for a period of 10 years for cultivation. Please see template for the prices and the sizes of farmland. </p>
                                        </div>
                                    </div>
                                    <!-- row -->
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="pt-30">
                                                <h4>Crops Template</h4>
                                                <div class="sep_holder_box width-100 mb-20">
                                                    <span class="sep_holder"><span class="sep_line"></span></span>
                                                    <span class="sep_holder"><span class="sep_line"></span></span>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <ul class="ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor">
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">For more information on Fennel Subscription <a href="https://www.agropark.com.ng/crop_production_download/fennel/hectare">Click Here</a> </span></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">For more information on Maize Subscription <a href="https://www.agropark.com.ng/crop_production_download/maize/hectare">Click Here</a> </span></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">For more information on Scent Leave  Subscription <a href="https://agropark.ng/theme1/scent-leave.pdf">Click Here</a> </span></li>
                                                            <!-- <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">accusantium doloremque laudantium.</span></li> -->
                                                        </ul>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <ul class="ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor">
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">For more information on Turmeric Subscription <a href="https://www.agropark.com.ng/crop_production_download/Turmeric/hectare">Click Here</a> </span></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">For more information on Citronella Subscription <a href="https://agropark.ng/theme1/citronella.pdf">Click Here</a> .</span></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><a href="https://agropark.ng/asset-files/investment-breakdown.pptx" > <span class="ttm-list-li-content">You can download this investment breakdown for further details</span> </a></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><a href="https://www.app.agropark.ng/" > <span class="ttm-list-li-content">Please click on this link to submit an application</span> </a> </li>
                                                            <!-- <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">combined with handful of model sentence and repudiated.</span></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">accusantium doloremque laudantium.</span></li> -->
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div><!-- row end-->
                                    <!-- row -->
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="pt-30">
                                                <h4>What to expect</h4>
                                                <div class="sep_holder_box width-100 mb-20">
                                                    <span class="sep_holder"><span class="sep_line"></span></span>
                                                    <span class="sep_holder"><span class="sep_line"></span></span>
                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-12">
                                                        <p><img class="alignright img-fluid" src="/img/land.png" alt="">1 Hectare of Farmland purchase (N1,550,000.00) with 7.5% VAT = N1,666,250.00</p>
                                                         <p>Crop production input cost is dependent on selected crop available on offer. Available crops are: •Fennel, •Maize, •Turmeric, •Citronella & •Scent leaves.</p>
                                                        <p>For instance, considering Fennel as a selected crop, cost of production of Fennel = N224,400.00</p>
                                                       <h5>Based on the above (Fennel):</h5>
                                                       <div class="row">
                                                    <div class="col-sm-12">
                                                        <ul class="ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor">
                                                           <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Total Cost of Investment: N1,666,250.00 + 224,400.00 = N1,890,650.00</span></li>                                                 <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Net Remittance In 6 Months = N108,540.94 
</span></li> 
                                                             <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">RoI (Return on Investment): N200,269.00
</span></li> 
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Crop life cycle: 4 months, 2 weeks</span></li> 
                                                        </ul>
                                                    </div>
                                                </div>  <br>
                                                <p>PS: Outright purchase is 90 years  •You can invest more than 1 hectare</p> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-lg-12">
                                
                                <div class="ttm-nextprev-bottom-nav">
                                    <nav class="navigation post-navigation">
                                        <div class="nav-links">
                                            <div class="nav-next"><router-link to="/cashcrop-subscription"  tag="a" rel="next"><span class="meta-nav" aria-hidden="true">Click To View Other Available Investment </span></router-link></div>
                                        </div>
                                    </nav>
                                </div>
                            </div> -->
                        </div><!-- ttm-pf-single-content-wrapper-innerbox end-->


                        <app-related-portfolio></app-related-portfolio>
                        
                    </div>
                </div>
            </div>
        </section>


        
      </div>

   </app-master>
</template>

<script>
// @ is an alias to /src
import Master from "@/components/Master.vue"
import Breadcrumb from "@/components/Breadcrumb.vue"
import RelatedPortfolio from "@/components/RelatedPortfolio.vue"
import { seo } from "../Repositories/seo"

export default {
  name: "Faq",
  mixins: [seo],
  components: {
    "app-master" : Master,
    "app-breadcrumb" : Breadcrumb,
    "app-related-portfolio": RelatedPortfolio

  },
  methods:{
     
  },
  created(){
      this.seoMetaData('Farmland Subscription', '');
  }

};
</script>


<style scoped>
  .show{
      display: block;
  }
</style>